








import Vue from "vue";
import { Component } from "vue-property-decorator";
import Header from "@/components/layout/Header.vue";
import Footer from "@/components/layout/Footer.vue";

@Component<App>({
  components: {
    Header,
    Footer,
  },
})
export default class App extends Vue {}
